import { render, staticRenderFns } from "./RecommendationPerformanceCharts.vue?vue&type=template&id=d4c591d0"
import script from "./RecommendationPerformanceCharts.vue?vue&type=script&lang=js"
export * from "./RecommendationPerformanceCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports